import React from "react";

import { InfoBlock, Text } from "@fragments";
import Parser from "@helpers/parser.js";
import MetricCard from "@pages/Banking/components/MetricCard";
import { walletBalanceCurrency, walletIsConnected } from "@helpers/wallets";

// The Global Wallet has no in-app withdrawal request: Stripe pays the
// connected bank account out automatically, in the account's settlement
// currency. The summary mirrors the numbers the Stripe Express dashboard
// shows for those payouts.
export default function StripePayoutSummary({ wallet, loading }) {
    if (!loading && !walletIsConnected(wallet)) return null;

    const currency = walletBalanceCurrency(wallet, "USD");
    const available = parseInt(wallet?.balance?.available, 10) || 0;
    const pending = parseInt(wallet?.balance?.pending, 10) || 0;
    const last4 = wallet?.onboarding?.externalAccountLast4;

    return (
        <div className="stripe-payout-summary mt-3">
            <Text.h3 weight={500} className="mb-2">
                Resumo de saques
            </Text.h3>

            <InfoBlock
                title="Como funcionam os saques internacionais?"
                description="Os saques da Global Wallet são payouts automáticos do Stripe para a conta bancária conectada, na moeda de liquidação da conta. A agenda de repasses é gerenciada no painel Stripe Express."
                className="mb-2"
            />

            <div className="metrics-row">
                <MetricCard
                    title="Disponível para saque"
                    metric={Parser.price.format(available, currency)}
                    submetric={currency}
                    loading={loading}
                />
                <MetricCard
                    title="A liberar"
                    metric={Parser.price.format(pending, currency)}
                    submetric="aguardando liquidação"
                    loading={loading}
                />
                <MetricCard
                    title="Conta de destino"
                    metric={last4 ? `•••• ${last4}` : "Stripe Express"}
                    submetric="payouts automáticos"
                    loading={loading}
                />
            </div>
        </div>
    );
}
